import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ArchiveHeader from "../../../components/ArchiveHeader";
import RoomForm from "./roomform";
import { injectIntl } from "react-intl";

const AddRoom = ({ history, match, intl, locale, setLocale }) => {
  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="add.edit.room" back backLink="/rooms" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col>
              <RoomForm history={history} match={match} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default injectIntl(AddRoom);
